import { Select } from '@noorden-insurtech/alba-design-system';
import { X } from 'lucide-react';
import { useEffect, useState } from 'react';
import { FilterFieldProps } from '../utils';

interface SelectOption {
  label: string;
  value: string;
}

interface SelectFilterFieldProps extends Omit<FilterFieldProps, 'value'> {
  items: SelectOption[];
  placeholder?: string;
  className?: string;
  onValueChange?: (value: string) => void;
  value?: string;
}

export function SelectFilterField({
  onChange,
  items,
  placeholder = 'Selecione...',
  className = '',
  onValueChange,
  value,
}: SelectFilterFieldProps) {
  const [currentValue, setCurrentValue] = useState<string>('');

  useEffect(() => {
    setCurrentValue(value || '');
  }, [value]);

  const handleChange = (details: { value: string[] }) => {
    const newValue = details.value[0] || '';
    setCurrentValue(newValue);
    onChange(newValue);
    if (onValueChange) {
      onValueChange(newValue);
    }
  };

  return (
    <Select.Root
      items={items}
      value={currentValue ? [currentValue] : []}
      onValueChange={handleChange}
      positioning={{ sameWidth: true }}
      className={className}
    >
      <Select.Control
        className='flex w-full group'
        data-has-current-value={!!currentValue}
      >
        <Select.Trigger className='w-full group-data-[has-current-value=true]:pr-9'>
          <Select.ValueText
            className='text-nowrap overflow-hidden text-ellipsis group-data-[has-current-value=false]:text-alba-gray-500'
            placeholder={placeholder}
          />
          <Select.Indicator>
            <svg
              className='h-4 w-4'
              fill='none'
              stroke='currentColor'
              viewBox='0 0 24 24'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M19 9l-7 7-7-7'
              />
            </svg>
          </Select.Indicator>
        </Select.Trigger>
        <Select.ClearTrigger
          type='button'
          className='absolute right-2 top-1/2 z-10 -translate-y-1/2 items-center justify-center rounded p-1 text-alba-gray-600 hover:bg-alba-gray-200 hover:text-alba-black-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-alba-blue-500 group-data-[has-current-value=true]:visible flex invisible'
          aria-label='Limpar seleção'
        >
          <X className='h-4 w-4' strokeWidth={1.6} />
        </Select.ClearTrigger>
      </Select.Control>
      <Select.Portal>
        <Select.Positioner>
          <Select.Content>
            {items.map(option => (
              <Select.Item key={option.value} item={option}>
                <Select.ItemText>{option.label}</Select.ItemText>
                <Select.ItemIndicator />
              </Select.Item>
            ))}
          </Select.Content>
        </Select.Positioner>
      </Select.Portal>
    </Select.Root>
  );
}
